import { IconButton, Pagination, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getPermissionData, getUserData } from "../../Actions/common";
import { deleteMultiplePlansAction, listAllPlansAction, updatePlanStatusAction } from "../../Actions/PlanManagementActions";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import { default as CoustomTooltip, default as CustomTooltip } from "../../Assets/customTheme/customtooltip";
import { MyAddRoundedIcon, MyDeleteOutlineOutlinedIcon, MyEditOutlinedIcon, MySearchIcon, MyWarningAmberIcon } from "../../Assets/svg/MyIcons";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { ITEMS_PER_PAGE_OPTIONS } from "../../config";
import CustomSnackbar from "../Common/snackBar";
import AddEditPlan from "./AddEditPlan";
import renderStatusBadge from "../../utils/badges";
import showConfirmation from "../../utils/Conformation";
import { CommonTooltip } from "../../utils/tooltip";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";

const DescriptionModal = ({ open, handleClose, description }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle className="card-header text-bg-primary fw-bold fs-2">Plan Description</DialogTitle>
      <DialogContent dividers>
        <Typography
          variant="body1"
          sx={{ fontSize: "16px", color: "#333", whiteSpace: "pre-line" }}
        >
          {description || "No description available."}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CustomToolbar = ({
  selectedRows,
  handleDeleteSelected,
  searchValue,
  handleSearchApi,
  handleFilterData,
  handleResetFilters,
  handleChangeDropdown,
  statusFilter,
  handleCreatePlan,
  hasPermission,
  filterButtonDisabled,
  resetButtonDisabled,
}) => {
  return (
    <div className="custom-header ">
      <div className="card border-rounded-0 fiter-card">
        <div className="card-body p-5 pb-0">
          <div className="row">
            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6  mb-5 ">
              <div className="input-group w-100">
                <div className="input-group-prepend">
                  <span
                    className="input-group-text"
                    id="basic-addon1"
                  >
                    <MySearchIcon />
                  </span>
                </div>
                <input
                  type="text"
                  data-kt-table-widget-4="search"
                  className="form-control"
                  placeholder="Search"
                  name="search"
                  value={searchValue}
                  onChange={handleSearchApi}
                />
              </div>
            </div>

            <div className="col-xl-3 col-xxl-2 col-lg-3 col-md-3 col-sm-6  mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={statusFilter}
                  name="dropdown"
                  onChange={(e) => handleChangeDropdown(e, "status")}
                  input={<OutlinedInput />}
                  sx={{
                    "& .MuiSelect-select": {
                      padding: "12px 10px",
                      textAlign: "start",
                      minHeight: "1em !important",
                    },
                    fieldset: {
                      borderColor: "#e1e3ea !important",
                      borderRadius: "0.475rem",
                    },
                  }}
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="0">Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="col-auto ms-auto d-flex gap-3 mb-5 align-items-center ">
              <CustomTooltip
                title="Filter"
                placement="top"
                arrow
              >
                <span>
                <button
                  className="btn text-primary btn-light btn-icon"
                  onClick={handleFilterData}
                  disabled={filterButtonDisabled}
                >
                  <TableFilte />
                </button>
                </span>
              </CustomTooltip>
              <CustomTooltip
                title="Reset"
                placement="top"
                arrow
              >
                <span>
                <button
                  className="btn text-primary btn-light btn-icon"
                  onClick={handleResetFilters}
                  disabled={resetButtonDisabled}
                >
                  <TableReset />
                </button>
                </span>
              </CustomTooltip>

              {/* <CoustomTooltip title="Column" placement="top" arrow>
                                        <span className="btn text-primary btn-light btn-icon grid-toolbar">
                                    
                                        <TableColumns/>

                                        
                                        </span>
                                    </CoustomTooltip> */}

              <CoustomTooltip
                title="Column Filter"
                placement="top"
                arrow
              >
                <span style={{ display: "inline-block" }}>
                  <GridToolbarColumnsButton
                    slotProps={{
                      tooltip: { title: "" },
                      button: {
                        className: "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                        style: {
                          width: "47px",
                          height: "44px",
                          minWidth: "unset",
                          borderRadius: "8px",
                        },
                        startIcon: <TableColumns />,
                      },
                    }}
                  />
                </span>
              </CoustomTooltip>

              {selectedRows.length !== 0 && (
                <CoustomTooltip
                  title="Delete"
                  placement="top"
                  arrow
                >
                  <span>
                    <button
                      className="btn btn-outline-danger btn-icon btn-outline "
                      onClick={handleDeleteSelected}
                      disabled={selectedRows.length === 0}
                    >
                      <MyDeleteOutlineOutlinedIcon />
                    </button>
                  </span>
                </CoustomTooltip>
              )}

              {hasPermission?.canCreate && (
                <button
                  className="btn btn-outline btn-primary btn-add  "
                  onClick={(e) => handleCreatePlan(e)}
                >
                  <MyAddRoundedIcon className="me-1 text-white" /> ADD
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PlanManagementListing = () => {
  const [plansListData, setPlansListData] = useState([]);
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
  const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("all");
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [shouldFetchData, setShouldFetchData] = useState(1);
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(ITEMS_PER_PAGE_OPTIONS[0]);
  const [currentId, setCurrentId] = useState(null);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState({
    isOpen: false,
    description: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const permissionData = localStorage.getItem(`${userData?.id}_permissionData`) ? getPermissionData(`${userData?.id}_permissionData`) : [];
  const hasPermission = permissionData[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "plan-management");
  const [activeUsersWarning, setActiveUsersWarning] = useState({
    isOpen: false,
    plan: null,
    actionType: null, // 'delete' or 'deactivate'
  });

    const getPlansList = useCallback( async () => {
    setLoading(true);
    await listAllPlansAction({
      page: currentPage,
      pageSize: selectedRowsPerPage,
      searchValue,
      status: statusFilter !== "all" ? statusFilter === "1" : null,
    })
      .then((res) => {
        const { data, totalRecords } = res?.data || {};
        setPlansListData(data);
        setTotalRecords(totalRecords);
        setLoading(false);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error?.message || "Something went wrong",
          severity: "error",
        });
        setLoading(false);
      });
    setLoading(false);
  },[currentPage,searchValue,selectedRowsPerPage,statusFilter]);

  useEffect(() => {
    if (shouldFetchData) {
      getPlansList();
      setShouldFetchData(0);
    }
  }, [shouldFetchData,getPlansList]);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  
  const handleTogglePlanStatus = async (e, plan) => {
      e.stopPropagation();

      // Check if plan has active users and is currently active
      if (plan.activeUsersCount > 0 && plan.isActive) {
          // Show warning dialog instead of deactivating
          setActiveUsersWarning({
              isOpen: true,
              plan: plan,
              actionType: "deactivate",
          });
          return;
      }

      const newStatus = !plan.isActive;
      const actionText = newStatus ? "Activate" : "Deactivate";

      const result = await Swal.fire({
          title: `${actionText} Plan?`,
          text: `Are you sure you want to ${actionText.toLowerCase()} the plan "${plan.name}" (v${plan.version})?`,
          icon: newStatus ? "question" : "warning",
          showCancelButton: true,
          confirmButtonColor: newStatus ? "#28a745" : "#dc3545",
          cancelButtonColor: "#777777",
          confirmButtonText: `Yes, ${actionText}`,
          cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
          try {
              const res = await updatePlanStatusAction(plan.id, {
                  isActive: newStatus,
              });

              setSnackbar({
                  open: true,
                  message: res.message || `Plan ${actionText.toLowerCase()}d successfully`,
                  severity: "success",
              });

              getPlansList();
          } catch (error) {
              setSnackbar({
                  open: true,
                  message: error?.message || "Failed to update plan status",
                  severity: "error",
              });
          }
      }
  };

  //  Active Users Warning Dialog
  const ActiveUsersWarningDialog = ({ open, handleClose, plan, actionType }) => {
      const actionText = actionType === "delete" ? "deleted" : "deactivated";
      const actionTitle = actionType === "delete" ? "Delete" : "Deactivate";

      return (
          <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
              <DialogTitle className="card-header text-bg-warning fw-bold fs-2 d-flex align-items-center">
                  <MyWarningAmberIcon className="me-2" />
                  Cannot {actionTitle} Plan
              </DialogTitle>
              <DialogContent dividers>
                  <Typography variant="body1" sx={{ fontSize: "16px", color: "#333", mb: 2 }}>
                      <strong>{plan?.name}</strong> (v{plan?.version}) cannot be {actionText} because it currently has{" "}
                      <strong style={{ color: "#28a745" }}>{plan?.activeUsersCount}</strong> active {plan?.activeUsersCount === 1 ? "user" : "users"}.
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: "14px", color: "#555" }}>
                      Please ensure all users are migrated to a different plan before attempting to {actionText.slice(0, -1)} this plan.
                  </Typography>
              </DialogContent>
              <DialogActions>
                  <Button onClick={handleClose} variant="contained" color="primary">
                      Understood
                  </Button>
              </DialogActions>
          </Dialog>
      );
  };

  const handleCreatePlan = async (e, id) => {
    if (id) {
      setCurrentId(id);
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
      if (openModal) setOpenModal(false);
      if (isDescriptionOpen.isOpen)
          setIsDescriptionOpen({
              isOpen: false,
              description: "",
          });
      if (activeUsersWarning.isOpen)
          setActiveUsersWarning({
              isOpen: false,
              plan: null,
              actionType: null,
          });
      setCurrentId(null);
  };

  const handleDeletePlan = async (e, deleteId) => {
      e.stopPropagation();

      // Find the plan to check active users
      const planToDelete = plansListData.find((p) => p.id === deleteId);

      // Check if plan has active users - Show warning dialog instead of deleting
      if (planToDelete && planToDelete.activeUsersCount > 0) {
          setActiveUsersWarning({
              isOpen: true,
              plan: planToDelete,
              actionType: "delete",
          });
          return;
      }

      // Proceed with normal deletion flow
      await showConfirmation("simpleDelete", {
          entityName: "Plan",
          entityId: deleteId,
          customText: "You will not be able to recover this plan!",
          action: async (id) => {
              return await deleteMultiplePlansAction(id);
          },
          onSuccess: () => {
              getPlansList();
          },
          onError: (error) => {
              setSnackbar({
                  open: true,
                  message: error.response?.data?.message,
                  severity: "error",
              });
          },
          showCancelledMsg: true,
      });
  };

  const handleSearchApi = (e) => {
    const inputValue = e.target.value.trim();
    setSearchValue(inputValue);
    if (inputValue.length > 0) {
      setFilterButtonDisabled(false);
    } else {
      setFilterButtonDisabled(true);
    }
  };

  // const handleRowSelection = (event, ele) => {
  //   const selectedId = ele.id;

  //   if (event.target.checked) {
  //     // Add the selected ID to the array
  //     setSelectedRows((prevSelectedRows) => [...prevSelectedRows, selectedId]);
  //   } else {
  //     // Remove the selected ID from the array
  //     setSelectedRows((prevSelectedRows) => prevSelectedRows.filter((id) => id !== selectedId));
  //   }
  // };

  // const handleSelectAll = (event) => {
  //   if (event.target.checked) {
  //     // Select all records
  //     const allIds = plansListData.map((ele) => ele.id);
  //     setSelectedRows(allIds);
  //   } else {
  //     // Deselect all records
  //     setSelectedRows([]);
  //   }
  // };

  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) {
      // No records selected
      return;
    }

    // Perform the deletion logic here
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover these Users!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#22419e",
      cancelButtonColor: "#777777",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteMultiplePlansAction(selectedRows)
          .then((res) => {
            Swal.fire({
              title: "Deleted!",
              text: res.data.message,
              icon: "success",
              confirmButtonColor: "#22419e",
            });
            // Clear selectedRows array after deletion
            setSelectedRows([]);
            setCurrentPage(1);
            // Refresh the data after deletion
            getPlansList();
          })
          .catch((error) => {
            setSnackbar({
              open: true,
              message: error.response?.data?.message,
              severity: "error",
            });
            setSelectedRows([]);
          });
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your record is safe",
          icon: "error",
          confirmButtonColor: "#22419e",
        });
        setSelectedRows([]);
      }
    });
  };

  const handlePaginationChange = (event, value) => {
    setPlansListData([]);
    setSelectedRows([]);
    setCurrentPage(value);
    setShouldFetchData(1);
  };

  const handleChangeDropdown = (e, filterName) => {
    const selectedAction = e.target.value;
    if (filterName === "status") {
      setStatusFilter(selectedAction);
    }
    if (selectedAction !== "all") {
      setFilterButtonDisabled(false);
    } else {
      setFilterButtonDisabled(true);
    }
  };

  const handleResetFilters = () => {
    setPlansListData([]);
    setStatusFilter("all");
    setSearchValue(""); // Resetting the search value
    setCurrentPage(1); // Resetting the current page to the first page
    setShouldFetchData(1);
    setResetButtonDisabled(true);
    setFilterButtonDisabled(true);
  };

  const handleFilterData = () => {
    setLoading(true);
    setCurrentPage(1);
    setShouldFetchData(1);
    setPlansListData([]);
    setLoading(false);
    setFilterButtonDisabled(true);
    setResetButtonDisabled(false);
  };

  useEffect(() => {}, []);

  const handleRowsPerPageChange = (event) => {
    setPlansListData([]);
    setSelectedRows([]);
    const newValue = parseInt(event.target.value);
    setSelectedRowsPerPage(newValue);
    setCurrentPage(1);
    setLoading(true);
    setShouldFetchData(1);
  };
  const columns = [
      // {
      //     field: "id",
      //     minWidth: 54,
      //     width: 54,
      //     headerName: "",
      //     sortable: false, // Disable sorting for this column
      //     filterable: false, // Disable filtering for this column
      //     disableColumnMenu: true,
      //     renderHeader: (params) => (
      //         <Checkbox
      //             onChange={handleSelectAll}
      //             disabled={plansListData.length === 0}
      //             checked={
      //                 plansListData.length > 0 &&
      //                 selectedRows.length === plansListData.length
      //             }
      //             sx={MyCheckboxIcon}
      //         />
      //     ),
      //     renderCell: (params) => (
      //         <Checkbox
      //             onChange={(event) => handleRowSelection(event, params.row)}
      //             checked={selectedRows.includes(params.row.id)}
      //             sx={MyCheckboxIcon}
      //         />
      //     ),
      // },
      {
          field: "name",
          headerName: "Plan Name",
          flex: 1,
          minWidth: 180,
          renderCell: (params) => (
              <span
                  style={{ fontSize: "16px", fontWeight: 500, color: "#333" }}
              >
                  {params.row.name || "N/A"}
              </span>
          ),
      },
      {
          field: "description",
          headerName: "Description",
          flex: 2,
          minWidth: 250,
          renderCell: (params) => {
              const text = params.row.description || "N/A";
              const maxLength = 40; // limit characters here
              const truncatedText =
                  text.length > maxLength
                      ? text.substring(0, maxLength) + "..."
                      : text;
              return (
                  <span
                      style={{
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#555",
                          cursor: "pointer",
                          textDecoration: "underline",
                      }}
                      onClick={() =>
                          setIsDescriptionOpen({
                              isOpen: true,
                              description: text,
                          })
                      }
                  >
                      {truncatedText}
                  </span>
              );
          },
      },
      {
          field: "monthly_price",
          headerName: "Monthly Price",
          flex: 1,
          minWidth: 120,
          renderCell: (params) => (
              <span
                  style={{ fontSize: "16px", fontWeight: 500, color: "#333" }}
              >
                  {params.row.monthly_price !== undefined
                      ? `CI$ ${params.row.monthly_price}`
                      : "N/A"}
              </span>
          ),
      },
      {
          field: "yearly_price",
          headerName: "Yearly Price",
          flex: 1,
          minWidth: 120,
          renderCell: (params) => (
              <span
                  style={{ fontSize: "16px", fontWeight: 500, color: "#333" }}
              >
                  {params.row.yearly_price !== undefined
                      ? `CI$ ${params.row.yearly_price}`
                      : "N/A"}
              </span>
          ),
      },
      // {
      //   field: "user_limit_value",
      //   headerName: "User Limit",
      //   flex: 1,
      //   minWidth: 120,
      //   renderCell: (params) => <span style={{ fontSize: "16px", fontWeight: 500, color: "#333" }}>{params.row.user_limit_value !== undefined ? params.row.user_limit_value : "N/A"}</span>,
      // },
      {
          field: "user_limit_type",
          headerName: "User Limit",
          flex: 1,
          minWidth: 150,
          sortable: false,
          align: "center", // centers the cell content
          headerAlign: "center", // centers the header text
          renderCell: (params) => {
              const statusMap = {
                  // 0:{ text: "limited", status: "warning" }
                  1: { text: "Unlimited", status: "success" },
              };
              const type = params.row?.user_limit_type;
              const value = params.row?.user_limit_value;

              if (statusMap[type]) {
                  const { text, status } = statusMap[type];
                  return renderStatusBadge({ status, title: text });
              }
              return value || "0";
          },
      },
      {
          field: "message_limit_type",
          headerName: "Message Limit",
          flex: 1,
          minWidth: 150,
          sortable: false,
          align: "center", // centers the cell content
          headerAlign: "center", // centers the header text
          renderCell: (params) => {
              const statusMap = {
                  // 0:{ text: "limited", status: "warning" }
                  1: { text: "Unlimited", status: "success" },
              };
              const type = params.row?.message_limit_type;
              const value = params.row?.message_limit_value;

              if (statusMap[type]) {
                  const { text, status } = statusMap[type];
                  return renderStatusBadge({ status, title: text });
              }
              return value || "0";
          },
      },
      {
          field: "agent_training_limit_type",
          headerName: "Agent Training Limit",
          flex: 1,
          minWidth: 150,
          sortable: false,
          align: "center", // centers the cell content
          headerAlign: "center", // centers the header text
          renderCell: (params) => {
              const statusMap = {
                  // 0:{ text: "limited", status: "warning" }
                  1: { text: "Unlimited", status: "success" },
              };
              const type = params.row?.agent_training_limit_type;
              const value = params.row?.agent_training_limit_value;

              if (statusMap[type]) {
                  const { text, status } = statusMap[type];
                  return renderStatusBadge({ status, title: text });
              }
              return value || "0";
          },
      },
      {
      field: "activeUsersCount",
      headerName: "Active Users",
      flex: 1,
      minWidth: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Chip
          label={params.row.activeUsersCount || 0}
          size="small"
          style={{
            fontWeight: 500,
            color: "white",
            backgroundColor: params.row.activeUsersCount > 0 ? "#28a745" : "#6c757d",
          }}
        />
      ),
    },
    {
          field: "version",
          headerName: "Version",
          flex: 1,
          minWidth: 100,
          align: "center", // centers the cell content
          headerAlign: "center", // centers the header text
          renderCell: (params) => (
              <Chip
                  label={params.row.version || 1}
                  size="small"
                  style={{
                      fontWeight: 500,
                      // backgroundColor: "#89a6ff"
                      color: "whitesmoke",
                      backgroundColor: "#22419e",
                  }}
              />
          ),
      },
      {
          field: "isActive",
          headerName: "Is Active",
          flex: 1,
          minWidth: 130,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => {
              const statusMap = {
                  true: { text: "Active", status: "success" },
                  false: { text: "Inactive", status: "default" },
              };

              const statusCode = params.row?.isActive ?? "0";
              const { text, status } = statusMap[statusCode] || {
                  text: "Unknown",
                  status: "default",
              };

              return renderStatusBadge({ status, title: text });
          },
      },
      ...(hasPermission?.canEdit || hasPermission?.canDelete || hasPermission?.canEmail
          ? [
                {
                    field: "actions",
                    headerName: "Action",
                    sortable: false,
                    minWidth: 150,
                    renderCell: (params) => (
                        <div className="d-flex align-items-center justify-content-center w-100 h-100">
                            {hasPermission?.canEmail && (
                                <CommonTooltip title={params.row?.isActive ? "Deactivate Tenant" : "Activate Tenant"}>
                                    <IconButton
                                        className="btn-custom-i text-primary me-3"
                                        onClick={(e) => handleTogglePlanStatus(e, params.row)}
                                    >
                                        <PowerSettingsNewOutlinedIcon
                                            color={params.row?.isActive ? "error" : "success"}
                                        />
                                    </IconButton>
                                </CommonTooltip>
                            )}
                            {hasPermission?.canEdit && (
                              <CommonTooltip title="Edit" placement="top" arrow>
                                <IconButton
                                    className="btn-custom-i text-primary me-3"
                                    onClick={(e) =>
                                        handleCreatePlan(e, params.row.id)
                                    }
                                >
                                    <MyEditOutlinedIcon />
                                </IconButton>
                                </CommonTooltip>
                            )}
                            {hasPermission?.canDelete && (
                              <CommonTooltip title="Delete" placement="top" arrow>
                                  <IconButton
                                      className="btn-custom-i text-primary"
                                      onClick={(e) =>
                                          handleDeletePlan(e, params.row.id)
                                      }
                                  >
                                      <MyDeleteOutlineOutlinedIcon />
                                  </IconButton>
                                </CommonTooltip>
                            )}
                        </div>
                    ),
                },
            ]
          : []),
  ];

  const handleToast = (severity, message) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  return (
    <div id="kt_content_container">
      <BreadcrumbsComponent />

      <DataGrid
        className="border-0"
        localeText={{ toolbarColumns: "" }}
        rows={plansListData}
        columns={columns}
        autoHeight
        hideFooterRowCount={true}
        hideFooterPagination={true}
        hideFooter={true}
        loading={loading}
        slots={{
          toolbar: CustomToolbar,
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        slotProps={{
          toolbar: {
            selectedRows,
            handleDeleteSelected,
            searchValue,
            handleSearchApi,
            handleFilterData,
            handleResetFilters,
            handleChangeDropdown,
            statusFilter,
            handleCreatePlan,
            plansListData,
            hasPermission,
            filterButtonDisabled,
            resetButtonDisabled,
          },
        }}
        components={{
          loadingOverlay: () => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
              }}
            >
              <CircularProgress
                color="primary"
                size={24}
                style={{
                  marginRight: 10,
                }}
              />
              Loading...
            </div>
          ),
          noRowsOverlay: () =>
            loading ? null : (
              <div
                style={{
                  display: !loading && plansListData.length === 0 ? "block" : "none",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                No Records Found
              </div>
            ),
        }}
        sx={DataGrid_SX}
      />
      <div className="card-footer d-flex align-items-center justify-content-between mt-7">
        <div className="d-flex align-items-center">
          <label className="fw-semibold me-3">{"Row per page"} </label>
          <FormControl
            variant="standard"
            style={{
              minWidth: 50,
            }}
          >
            <Select
              labelId="rows-per-page-label"
              id="rows-per-page"
              value={selectedRowsPerPage}
              onChange={handleRowsPerPageChange}
              label="Row per page"
            >
              {ITEMS_PER_PAGE_OPTIONS?.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <Pagination
          count={Math.ceil(totalRecords / selectedRowsPerPage)}
          siblingCount={0}
          page={currentPage}
          onChange={(event, value) => (value !== currentPage ? handlePaginationChange(event, value) : null)}
          variant="outlined"
          shape="rounded"
          className="custom-pagination mt-0 ms-5"
        />
      </div>
      {openModal && (
        <AddEditPlan
          open={openModal}
          handleClose={handleCloseModal}
          id={currentId}
          refetchPlanList={getPlansList}
          handleToast={handleToast}
        />
      )}
      {isDescriptionOpen && (
        <DescriptionModal
          open={isDescriptionOpen.isOpen}
          handleClose={handleCloseModal}
          description={isDescriptionOpen.description}
        />
      )}
      {activeUsersWarning.isOpen && (
          <ActiveUsersWarningDialog
              open={activeUsersWarning.isOpen}
              handleClose={handleCloseModal}
              plan={activeUsersWarning.plan}
              actionType={activeUsersWarning.actionType}
          />
      )}
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
};

export default PlanManagementListing;
